import { object, string, ref } from 'yup'
import { userService } from './services'

export const phoneRegexp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/

const firstName = string().required('First Name is required')

const lastName = string().required('Last Name is required')

const displayName = string().required('Display Name is required')

const permission = string().required('Permission level is required')

const companyId = string().required('Company is required')

const domainId = string().required('Domain is required')

const email = string().email('Enter a valid email').required('Email is required')

const userId = string()
    .matches(/^[a-zA-Z0-9\-_@.]{0,40}$/, 'Please use only alpha-numeric without spaces or email address')
    .required('User Name is required')

const userIdNew = userId.test('is-existing-user', 'A user with this id already exists', async userId => {
    if (!userId) return true
    return userService.search(userId).then(results => {
        if (!results) return true
        return !Object.keys(results).includes(userId.toLowerCase())
    })
})

const password = string().required('Current password is required')

const newPassword = string()
    .required('New Password is required')
    .min(8, 'Password must contain at least 8 characters')
    .matches(
        /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[a-z])(?=.*[0-9]).{8,}$/,
        'Password must contain at least one Uppercase Letter, Lowercase Letter, Special Character, and Number'
    )

const confirmPassword = string()
    .required('Confirm your password')
    .oneOf([ref('newPassword')], 'Password does not match')

export const account = object({ firstName, lastName, displayName, email })

export const chgPassword = object({ password, newPassword, confirmPassword })

const createUserBase = { firstName, lastName, userId: userIdNew, email, companyId, domainId }
const addUserBase = { firstName, lastName, userId, email }

export const createUser = object(createUserBase)

export const addUser = object(addUserBase)

export const createContextUser = object({ ...createUserBase, permission })

export const addContextUser = object({ ...addUserBase, permission })
